module.exports = __webpack_public_path__ + "media/src/website/images/locations/eggstaett/eggstaett_02-d0402ecfd21fb66bc82584ab8db30fca.jpg";